module.exports = require("./kkj.js");